import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  RoutingGroup,
  useRoutingGroupsTableContext,
} from '../../../../RoutingGroupsTableContext'
import { Permission } from '@cims-online/shared'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useRestoreCasRoutingGroupMutation } from 'schema'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestoreOptions(): RestoreRowActionOptions<RoutingGroup> {
  const { refetch } = useRoutingGroupsTableContext()
  const [restore] = useRestoreCasRoutingGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreCASRoutingGroup: {
        routingGroup: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreCASRoutingGroup,
    default: 'active',
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
  }
}
